import { Component, OnDestroy, OnInit, HostBinding, SecurityContext } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { UserPreferences } from '@models/user-preferences';
import { XmModal } from '@optek/xm-bootstrap';
import { UserService } from '@services/user.service';
import { Subscription } from 'rxjs';
import { HeaderService } from '../header/header.service';
import { Notification } from '@models/release-notes/notification';
import { appVersion } from '../../../environments/environment';
import { ProfileNotificationService } from '../header/profile/profile-notification/profile-notification.service';
import { DistanceType } from '@models/measurements';
import { AuthenticationService } from '@services/authentication.service';

@Component({
  selector: 'app-profile-overlay',
  templateUrl: './profile-overlay.component.html',
  styleUrls: ['./profile-overlay.component.scss']
})
export class ProfileOverlayComponent implements OnInit, OnDestroy {

  @HostBinding('class.overlay-active') isMiniProfileVisible: boolean;

  user: any;
  version = appVersion;
  userPreferences: UserPreferences = new UserPreferences();
  userThemes = this.userService.userThemes;
  distanceOptions = this.userService.measurementOptions.distances;
  subs: Subscription[] = [];
  notifications: Notification[];
  profileImageStyle: string | null;

  constructor(
    private userService: UserService,
    private modalService: XmModal,
    private headerService: HeaderService,
    private domSanitizer: DomSanitizer,
    private notificationService: ProfileNotificationService,
    private router: Router,
    private authService: AuthenticationService,
  ) {
    this.subs.push(
      this.headerService.headerStates$().subscribe((headerStates: { [key: string]: boolean }) => {
        if (headerStates) {
          this.isMiniProfileVisible = headerStates.isMiniProfileActive;
        }
      })
    );
  }

  ngOnInit() {
    this.user = this.userService.user;
    this.fetchNotifications();
    this.profileImageStyle = this.domSanitizer.sanitize(SecurityContext.STYLE, this.userService.getProfileImageStyle(this.user.photo));
    this.subs.push(
      this.userService.userPreferences$.subscribe(userPreferences => {
        if (userPreferences) {
          this.userPreferences = userPreferences;
        }
      })
    );
  }

  notificationTag(notification: Notification) {
    return `notification-${notification.id}`;
  }

  /**
   * Populates notification array | sets active notifications true | sets notifications total
   * @returns no return
   */
  fetchNotifications() {
    this.notificationService.getNotifications().subscribe(notifications => {
      this.notifications = notifications.filter(notification => notification.type === 'release').map((notification) => {
        const notificationStorageId = this.notificationTag(notification);
        if (localStorage.getItem(notificationStorageId)) {
          notification.read = true;
        }
        return notification;
      }).filter((notification: Notification) => !notification.read);
    });
  }

  handleLogOutModal(content: any) {
    this.resetNavItemDropdowns();
    this.modalService.open(content, {
      lightboxMode: true,
      centered: true
    });
  }

  logout() {
    this.resetNavItemDropdowns();
    this.authService.logout();
  }

  saveUserThemeDropdown(theme: string) {
    this.userService.saveTheme(theme);
    this.resetNavItemDropdowns();
  }
  saveUserDistanceDropdown(distance: DistanceType): void {
    this.userService.saveDistance(distance);
    this.resetNavItemDropdowns();
   }

  resetNavItemDropdowns() {
    this.headerService.updateHeaderStates({
      isMiniProfileActive: false
    });
  }

  profileRoute() {
    this.router.navigate(['profile']);
    this.resetNavItemDropdowns();
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

}
